export default function Cart({
  cartItems,
  increaseQuantity,
  decreaseQuantity,
  removeItem,

  // Additional props
  // products,
  findProduct,
}) {
  // const findProduct = (pId) => {
  //   return products.find((product) => {
  //     return product.id === pId;
  //   });
  // };

  return (
    <>
      <h2>Cart Items</h2>

      {cartItems.length === 0 ? (
        <p className="empty">No products added yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {cartItems.map((cartItem) => {
              const item = findProduct(cartItem.pId);

              if (!item) return null;

              return (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>₹{item.price}</td>

                  <td>
                    <div className="quantity-container">
                      <button
                        className="qty-btn"
                        onClick={() => {
                          decreaseQuantity(cartItem.cid);
                        }}
                      >
                        -
                      </button>

                      <span className="qty-value">{cartItem.quantity}</span>

                      <button
                        className="qty-btn"
                        onClick={() => {
                          increaseQuantity(cartItem.cid);
                        }}
                      >
                        +
                      </button>
                    </div>
                  </td>

                  <td>₹{item.price * cartItem.quantity}</td>

                  <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        removeItem(cartItem.cid);
                      }}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
